module.exports = __webpack_public_path__ + "static/office_10-3f37c8eca8b7e1d723582ce65e113025.jpg";